import { render, staticRenderFns } from "./pie_chart_widget.vue?vue&type=template&id=84fcb282&"
import script from "./pie_chart_widget.vue?vue&type=script&lang=js&"
export * from "./pie_chart_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports